<template>
  <div>
    <div class="p-16">
      <div class="max-w-5xl mx-auto space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500">
            {{ $t('pages') | capitalize }}
          </h4>
        </div>
        <PageListComponent
          :fetching="fetching"
          :pages="accountPages"
          :meta="meta"
          :actionable="$membershipHasPermissionTo('edit pages,delete pages')"
          @get-pages="handleGetPages"
        >
          <template #item-title="{ page }">
            <RouterLink :to="getRoute(page)">
              {{ page.title }}
            </RouterLink>
          </template>
          <template #item-actions="{ page, actionClicked }">
            <DataIteratItemActions
              :page-id="page.id"
              route-base-name="accounts.pages"
              :can-edit="$membershipHasPermissionTo('edit pages')"
              :can-delete="$membershipHasPermissionTo('delete pages')"
              v-on="{ actionClicked }"
            />
          </template>
        </PageListComponent>
        <div>
          <RouterView name="modal" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { middleware } from '@/routes/guards';
import { accountPageComputed, accountPageMethods } from '@/store/helper';
import PageListComponent from '@/components/Pages/List.vue';
import DataIteratItemActions from '@/components/Pages/DataIteratItemActions.vue';

export default {
  name: 'PageList',
  components: {
    PageListComponent,
    DataIteratItemActions,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    fetching: false,
  }),
  computed: {
    ...accountPageComputed,
  },
  beforeRouteEnter: middleware('account-permission:read pages'),
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...accountPageMethods,
    getRoute({ id: pageId }) {
      const { accountId } = this;
      return {
        name: 'accounts.pages.preview',
        params: {
          accountId,
          pageId,
        },
      };
    },
    handleGetPages(params = {}) {
      const { accountId } = this;
      this.fetching = true;
      this.getAccountPages({
        accountId,
        queryParams: {
          ...params,
          include: 'tags',
        },
      })
        .then(() => {
          this.fetching = false;
        })
        .catch(() => {
          this.fetching = false;
        });
    },
  },
};
</script>
